<button (click)="openSaveViewDialog()" mat-flat-button class="button__small button__text text-gray">
  Save</button>